'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enoughTimeHasPassedForNewAutomatedChatMessage = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _ThreadHistoryConstants = require('../constants/ThreadHistoryConstants');

var _lastMessage = require('./lastMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enoughTimeHasPassedForNewAutomatedChatMessage = exports.enoughTimeHasPassedForNewAutomatedChatMessage = function enoughTimeHasPassedForNewAutomatedChatMessage(threadHistory) {
  if (!threadHistory) {
    return false;
  }

  var latestMessageTimestamp = (0, _pipe2.default)(_lastMessage.lastMessage, _commonMessageFormatGetters.getTimestamp)(threadHistory);

  return Date.now() - latestMessageTimestamp >= _ThreadHistoryConstants.SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/enoughTimeHasPassedForNewAutomatedChatMessage.js
// module id = 254
// module chunks = 2 3